import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Label, Loader, Icon } from "semantic-ui-react";
import { withRouter, Redirect } from "react-router-dom";
import { assignSecretary, unassignSecretary } from "services/prescription";
import { setFocusedFolders, setSecretaryMode, getListExpress } from "services/folder";
import {} from "services/campaign";
import { getSyncRounds } from "services/round";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import FoldersOverview from "features/FoldersOverview";
// import moment from 'moment';
import MainButton from "components/Buttons/MainButton";
import {
	getNextFolderToValidate,
	getNextFolderFuture,
	getFoldersToValidate,
	getFoldersFuture,
	getFoldersCount,
	getFoldersPaused,
	closeAllMyOpenedFolder,
} from "services/folder";
import { getMpiPatientByMatricule, searchPatientsMyLab, postPatientMyLab } from "services/patient";
import { getCampaignRecordsToAssign, getNextPatientToAssign, saveAssignation, cancelAssignation } from "services/campaign";
import { setOpenTab, setTvSecMode } from "services/secretaryMode";
import { toast } from "react-toastify";
import FolderList from "./components/FolderList";
import { setTab } from "services/foldersOverview";
import TvSecretariat from "./components/TvSecretariat";
import {
	getAllFolderHelp,
	getStatsSecretaryHome,
	getAssignedToMeFolderHelp,
	postAssignToMe,
	acceptSupportFolderHelp,
	getLastFoldersSupported,
	getAllSecretaries,
} from "services/folderHelp";
import { setSoundNotification, setMyTelForTvSec } from "services/user";
import { Trans } from "react-i18next";
import { getListPreregisters } from "services/preregister";

const styles = {
	containerStyle: {
		paddingTop: 30,
	},
	tabs: {
		list: {
			borderBottom: 0,
			marginBottom: 0,
			height: 40,
			display: "flex",
			width: "100%",
		},
	},
	contentStyle: {
		height: 50,
		lineHeight: "50px",
	},
	roundHeaderContainer: {
		height: 50,
		backgroundColor: "#43b39e",
		width: "100%",
		padding: 10,
		display: "flex",
		borderRadius: "4px 4px 0 0",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		position: "relative",
	},
	columnFlex: {
		display: "flex",
		width: "50%",
		height: "100%",
		alignItems: "center",
	},
	datePicker: {
		height: "100%",
		border: 0,
		background: "transparent",
		color: "#fff",
		fontWeight: 600,
	},
	icon: {
		color: "#fff",
		fontSize: "1.5em",
		marginRight: 5,
	},
	patient: {
		name: {
			display: "inline-block",
			width: "40%",
			fontWeight: "bold",
		},
		birthdate: {
			display: "inline-block",
			width: "30%",
			textAlign: "center",
			fontWeight: "bold",
		},
		socialNumber: {
			display: "inline-block",
			width: "30%",
			textAlign: "right",
			fontWeight: "bold",
		},
	},
	accordion: {
		width: "100%",
		backgroundColor: "rgb(232, 232, 232)",
		minHeight: 100,
		borderTop: "1px solid #cfcfcf",
		boxShadow: "rgb(76, 76, 76) 0px 6px 9px -10px inset",
		padding: 10,
		marginTop: "1em",
	},
};

const _tabActive = (active, side) => ({
	backgroundColor: active ? "#42b39e" : "transparent",
	color: active ? "#fff" : "#42b39e",
	height: "100%",
	width: "50%",
	border: "1px solid #42b39e",
	borderRadius: side === "left" ? "10px 0 0 10px" : side === "center" ? "0" : side === "solo" ? "10px" : "0 10px 10px 0",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
});

class SecretaryHome extends Component {
	constructor(props) {
		super(props);

		this.state = {
			openFolderManager: null,
			doneFolderHelps: false,
			preregisterFolderHelps: false,
			dashboardOpened: false,
			tvSecMode: "",
		};
	}

	componentDidMount() {
		const { openedTab } = this.props.secretaryMode;
		this.changeTabIndex(openedTab);
	}

	loadAll = () => {
		this.props.getAssignedToMeFolderHelp();
		this.props.getStatsSecretaryHome();
		this.props.getCampaignRecordsToAssign();
		this.props.getAllSecretaries();
	};

	changeDoneFolderHelpsList = () => {
		this.props.getAllFolderHelp(this.props.folderHelp.pagination.page, !this.state.doneFolderHelps, this.state.preregisterFolderHelps, 50);
		this.setState({ doneFolderHelps: !this.state.doneFolderHelps });
	};
	changePreregisterFolderHelpsList = () => {
		this.props.getAllFolderHelp(this.props.folderHelp.pagination.page, this.state.doneFolderHelps, !this.state.preregisterFolderHelps, 50);
		this.setState({ preregisterFolderHelps: !this.state.preregisterFolderHelps });
	};

	changeTabIndex = (index) => {
		this.props.getFoldersCount();
		const { openedTab } = this.props.secretaryMode;
		if (index !== openedTab) this.props.setOpenTab(index);
		if (index === 0) this.props.setSecretaryMode("create");
		else if (index === 1) {
			this.props.setSecretaryMode("future");
			// this.props.getSyncRounds(0, moment().format('YYYY-MM-DD')).then(() => {
			// 	this.props.getFoldersFuture();
			// });
		} else if (index === 2) {
			this.props.setSecretaryMode("validate");
			this.props.getFoldersToValidate(1, 20);
		} else if (index === 3) {
			this.props.setSecretaryMode("validate");
			this.props.getFoldersPaused(1, 20);
		}
	};

	goToFolderManager = (id) => {
		if (id) this.props.setFocusedFolders([id]);
		this.setState({ openFolderManager: true });
	};

	takeNextFuturePrescription = () => {
		this.props.setSecretaryMode("future");
		this.props.getNextFolderFuture().then((response) => {
			if (!response.payload.data || !response.payload.data.id) {
				toast.warn("Tous les dossiers sont déjà en cours de validation");
			} else {
				const folder = response.payload.data;
				this.props.setFocusedFolders([folder.id]);
				folder.prescriptions.forEach((prescri) => {
					this.props.assignSecretary(prescri);
				});
				this.goToFolderManager();
			}
		});
	};

	takeNextToValidatePrescription = (paused = false) => {
		this.props.setSecretaryMode("validate");
		this.props.getNextFolderToValidate(paused).then((response) => {
			if (!response.payload.data || !response.payload.data.id) {
				toast.warn("Tous les dossiers sont déjà en cours de validation");
			} else {
				const folder = response.payload.data;
				this.props.setFocusedFolders([folder.id]);
				folder.prescriptions.forEach((prescri) => {
					this.props.assignSecretary(prescri);
				});
				this.goToFolderManager();
			}
		});
	};

	selectPatient = (folder, secretaryMode) => {
		this.props.setSecretaryMode(secretaryMode);
		this.props.setFocusedFolders([folder.id]);
		this.setState({ openFolderManager: true });
	};

	closeAllMyAssignedAndOpenedFolder = () => {
		this.props.closeAllMyOpenedFolder().then(() => this.props.getAssignedToMeFolderHelp());
	};
	getAllFolderHelp = () => {
		this.props.getAllFolderHelp(this.props.folderHelp.pagination.page, this.state.doneFolderHelps, this.state.preregisterFolderHelps);
		this.props.setTvSecMode("tvsec");
	};
	getListExpress = (args) => {
		this.props.getListExpress({ args });
		this.props.setTvSecMode("express");
	};
	getListPreregisters = (args) => {
		this.props.getListPreregisters(args);
		this.props.setTvSecMode("preregisters");
	};

	render() {
		const { toValidate, futures, count, openedTab, paused, tvSecMode } = this.props.secretaryMode;
		const { generalParameters, user, folderHelp, tvsec } = this.props;
		const { center } = user.session;
		const { preregisterFolderHelps, campaignMpi, myLabResults, myLabPagination } = this.state;

		if (this.state.openFolderManager) {
			return <Redirect to="/home/foldermanager" />;
		} else if (futures.loading && toValidate.loading) {
			return (
				<div style={{ width: "100%", textAlign: "center", marginTop: "2em" }}>
					<Loader active inline />
				</div>
			);
		} else {
			return (
				<div style={styles.containerStyle}>
					<Tabs
						onSelect={(i) => {
							this.changeTabIndex(i);
						}}
						selectedIndex={openedTab}
						forceRenderTabPanel
					>
						<Grid>
							<Grid.Row style={{ marginTop: "0.5em" }}>
								<Grid.Column
									mobile={16}
									tablet={16}
									computer={16}
									style={{
										display: "flex",
										alignItems: "center",
										padding: 0,
										marginLeft: 10,
										marginRight: 10,
									}}
								>
									<MainButton
										text={<Icon name="home" style={{ margin: 0 }} />}
										style={{ height: 40 }}
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.props.setOpenTab(0);
											this.props.setTab(0);
											this.props.resetMode();
										}}
									/>

									<TabList style={styles.tabs.list}>
										{center && (
											<Tab style={_tabActive(openedTab === 0, generalParameters.data.disableFolderSecondValidation ? "solo" : "left")}>
												<Trans i18nKey="secretaryhome.creation" />
											</Tab>
										)}

										{!generalParameters.data.disableFolderSecondValidation && (
											<>
												<Tab style={_tabActive((center && openedTab === 1) || (!center && openedTab === 0), "center")}>
													<Trans i18nKey="secretaryhome.preset" />
													<Label color="olive" size="mini" floating>
														{count.futures}
													</Label>
												</Tab>

												<Tab style={_tabActive((center && openedTab === 2) || (!center && openedTab === 1), "center")}>
													<Trans i18nKey="secretaryhome.validation" />
													<Label color="olive" size="mini" floating>
														{count.toValidate}
													</Label>
												</Tab>
												<Tab style={_tabActive((center && openedTab === 3) || (!center && openedTab === 2), "right")}>
													<Trans i18nKey="secretaryhome.inpause" />
													<Label color="olive" size="mini" floating>
														{count.paused}
													</Label>
												</Tab>
											</>
										)}
									</TabList>
								</Grid.Column>
								<Grid.Column mobile={16} tablet={12} computer={12} style={{ display: "flex", alignItems: "center" }}></Grid.Column>
							</Grid.Row>

							<Grid.Row style={{ padding: 0, marginTop: "2em" }}>
								<Grid.Column mobile={16} tablet={16} computer={16}>
									{!center && tvsec && (
										<TvSecretariat
											isLoading={false}
											done={this.state.doneFolderHelps}
											preregister={preregisterFolderHelps}
											changePreregister={this.changePreregisterFolderHelpsList}
											totalFolderHelps={folderHelp && folderHelp.list ? folderHelp.list.length : 0}
											folderHelps={folderHelp.list}
											changeDone={this.changeDoneFolderHelpsList}
											goToFolderManager={this.goToFolderManager}
											stats={folderHelp.stats}
											pagination={this.props.folderHelp.pagination}
											getAllFolderHelp={this.getAllFolderHelp}
											postAssignToMe={this.props.postAssignToMe}
											session={this.props.user.session}
											myNurseFolderHelps={this.props.folderHelp.myNurseFolderHelps}
											acceptSupportFolderHelp={this.props.acceptSupportFolderHelp}
											otherFoldersOpened={this.props.folderHelp.otherFoldersOpened}
											loadAll={this.loadAll}
											countMyFolders={this.props.folderHelp.countMyFolders}
											closeAllMyAssignedAndOpenedFolder={this.closeAllMyAssignedAndOpenedFolder}
											campaignsRecords={this.props.campaigns?.recordsCount}
											searchPatientsMyLab={this.props.searchPatientsMyLab}
											generalParameters={generalParameters}
											getNextPatientToAssign={this.props.getNextPatientToAssign}
											savePatientMatcher={this.props.saveAssignation}
											getMpiPatientByMatricule={this.props.getMpiPatientByMatricule}
											patientsSearch={this.props.patients.search}
											cancelAssignation={this.props.cancelAssignation}
											postPatientMyLab={this.props.postPatientMyLab}
											getCampaignRecordsToAssign={this.props.getCampaignRecordsToAssign}
											getLastFoldersSupported={this.props.getLastFoldersSupported}
											setMyNotificationSound={this.props.setSoundNotification}
											preregistersList={this.props.preregisterResults}
											getListPreregisters={this.getListPreregisters}
											secretariesUserList={this.props.folderHelp.secretaries}
											setMyTelForTvSec={this.props.setMyTelForTvSec}
											getListExpress={this.getListExpress}
											expressList={this.props.expressList}
											tvSecMode={tvSecMode}
										/>
									)}

									{center && (
										<TabPanel>
											<FoldersOverview
												openSidebar={this.props.openSidebar}
												hideSidebar={this.props.hideSidebar}
												resetMode={this.props.resetMode}
												safeplaceQR={this.props.safeplaceQR}
												campaignQR={this.props.campaignQR}
											/>
										</TabPanel>
									)}

									{!generalParameters.data.disableFolderSecondValidation && (
										<>
											<TabPanel>
												<FolderList
													data={futures}
													nextHandler={this.takeNextFuturePrescription}
													loadList={this.props.getFoldersFuture}
													generalParameters={generalParameters}
													selectPatient={this.selectPatient}
													user={user}
													action="future"
													actionText="à pré-saisir"
												/>
											</TabPanel>

											<TabPanel>
												<FolderList
													data={toValidate}
													nextHandler={this.takeNextToValidatePrescription}
													loadList={this.props.getFoldersToValidate}
													generalParameters={generalParameters}
													selectPatient={this.selectPatient}
													user={user}
													action="validate"
													actionText="à valider"
												/>
											</TabPanel>
											<TabPanel>
												<FolderList
													data={paused}
													nextHandler={() => this.takeNextToValidatePrescription(true)}
													loadList={this.props.getFoldersPaused}
													generalParameters={generalParameters}
													selectPatient={this.selectPatient}
													user={user}
													action="validate"
													actionText="en pause"
												/>
											</TabPanel>
										</>
									)}
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Tabs>
				</div>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		prescriptions: state.prescriptions,
		secretaryMode: state.secretaryMode,
		generalParameters: state.generalParameters,
		folderHelp: state.folderHelp,
		expressList: state.express?.list,
		user: state.user,
		dualScreen: state.dualScreen,
		safeplaceQR: state.safeplace.safeplaceQR,
		campaignQR: state.campaigns.campaignQR,
		campaigns: state.campaigns,
		patients: state.patients,
		preregisterResults: state.preregister?.secList,
	};
};

const mapDispatchToProps = {
	getFoldersToValidate,
	getFoldersPaused,
	getFoldersFuture,
	assignSecretary,
	unassignSecretary,
	setFocusedFolders,
	setSecretaryMode,
	getSyncRounds,
	getNextFolderToValidate,
	getNextFolderFuture,
	getFoldersCount,
	setOpenTab,
	setTab,
	getAllFolderHelp,
	getStatsSecretaryHome,
	getAssignedToMeFolderHelp,
	postAssignToMe,
	acceptSupportFolderHelp,
	closeAllMyOpenedFolder,
	getCampaignRecordsToAssign,
	getNextPatientToAssign,
	saveAssignation,
	getMpiPatientByMatricule,
	searchPatientsMyLab,
	cancelAssignation,
	postPatientMyLab,
	getLastFoldersSupported,
	setSoundNotification,
	getListPreregisters,
	getAllSecretaries,
	setMyTelForTvSec,
	getListExpress,
	setTvSecMode,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SecretaryHome));
